module.exports = __webpack_public_path__ + "static/media/shingan_doc_artist-support.8913e1b2.png";